import { render } from "./QuizComponent.vue?vue&type=template&id=4d3f567c&ts=true"
import script from "./QuizComponent.ts?vue&type=script&lang=ts&external"
export * from "./QuizComponent.ts?vue&type=script&lang=ts&external"

import "./QuizComponent.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__